import * as yup from "yup";

export const AddRequiredEvidenceTypeFormValidationSchema: yup.AnyObjectSchema =
    yup.object({
        evidenceTypeId: yup.number().required("Please enter an evidence type"),
    });

export type AddRequiredEvidenceTypeFormValues = {
    evidenceTypeId: number;
};
